const monthlyPricing = {
    MODEL: 99
}

export default monthlyPricing;